import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiErrorDetail } from "@/lib/api";
import { ArrowRight, Lock } from "lucide-react";
import { toast, Toaster } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  if (user === null) return <div className="pt-40 wrap">Loading…</div>;
  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, pw);
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[var(--bg-2)] pt-24">
      <Toaster richColors position="top-right" />
      <form onSubmit={submit} data-testid="admin-login-form" className="bg-white border border-neutral-200 rounded-3xl p-10 w-full max-w-md">
        <div className="w-12 h-12 rounded-full bg-[var(--red)] text-white grid place-items-center"><Lock size={20}/></div>
        <h1 className="h-display text-3xl uppercase mt-6">Admin</h1>
        <p className="text-sm text-neutral-500 mt-1">928 Wraps · lead dashboard</p>
        <div className="mt-8 space-y-4">
          <input required data-testid="admin-email" type="email" placeholder="Email" className="input-928" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input required data-testid="admin-password" type="password" placeholder="Password" className="input-928" value={pw} onChange={(e) => setPw(e.target.value)} />
        </div>
        <button disabled={loading} data-testid="admin-login-submit" className="btn-red mt-6 w-full justify-center">{loading ? "Signing in…" : "Sign in"} <ArrowRight size={16}/></button>
      </form>
    </div>
  );
}
